import { LoadingComponent } from "@pga/pga-component-library";
import React, { Fragment } from "react";
import { Query, Mutation } from "@apollo/client/react/components";
import { ErrorPage } from "../components/ErrorScreen";

export const GraphQLQuery = ({
  query,
  variables,
  loadingComp = () => <LoadingComponent fullscreen />,
  errorComp = (error) => <ErrorPage global error={error} />,
  ...props
}) => (
  <Query query={query} variables={variables}>
    {({ data, loading, error }) => {
      if (loading && loadingComp) return loadingComp(loading);
      if (error && errorComp) return errorComp(error);
      return <Fragment>{props.children({ data })}</Fragment>;
    }}
  </Query>
);

export const GraphQLMutation = ({
  mutation,
  loadingComp = () => <LoadingComponent fullscreen />,
  errorComp = (error) => <ErrorPage global error={error} />,
  dataComp = null,
  onCompleted = null,
  ...props
}) => (
  <Mutation mutation={mutation} onCompleted={onCompleted}>
    {(mutate, { data, loading, error }) => {
      if (loading && loadingComp) return loadingComp(loading);
      if (error && errorComp) return errorComp(error);
      if (data && dataComp) return dataComp(data);
      return props.children({ mutate: mutate });
    }}
  </Mutation>
);
